<div>
  <div
    [ngClass]="{
      'd-none':
        (this.contentSecondNav.length > 0 || this.contentChild.length > 0) &&
        this.isAppNavLinksMob
    }"
    class="container secondaryLinksContainer"
  >
    <div class="links-container"></div>
    <div class="row">
      <div
        *ngIf="secondNavImage"
        class="col-lg-3 d-none d-lg-block col-image pl-lg-0"
      >
        <img
          [attr.alt]="secondNavImageAlt"
          [src]="secondNavImage"
          class="img-fluid secondNavImage"
        />
      </div>
      <div class="col-lg-3 col-md-12 col-primary-links">
        <ul class="list-unstyled m-lg-0">
          <li *ngFor="let navItem of contentSecondNav; let x = index">
            <a
              (click)="
                setTrackingObject(navItem.brandLabel, $event, navItem.targetUrl)
              "
              (keydown)="onKyePress($event)"
              (mouseover)="secondNavMouseOver(navItem)"
              [attr.href]="navItem.targetUrl"
              [attr.target]="
                navItem?.openinnewTab === 'true' ? '_blank' : '_self'
              "
              class="secondNavLinks"
              data-src="travel-info_360_deltaOne.jpg"
              id="primary-static-link-{{ x }}"
            >
              {{ navItem.brandLabel }}
              <img
                *ngIf="navItem.externalimage === 'true'"
                [src]="externalImgUrl"
                alt="{{ externalImgDesc }}"
              />
            </a>
          </li>
        </ul>
      </div>
      <div class="col-lg-6 col-md-12 col-secondary-links">
        <ul class="list-unstyled">
          <li *ngFor="let childPage of this.contentChild; let y = index">
            <a
              (click)="
                setTrackingObject(childPage.pageName, $event, childPage.pageUrl)
              "
              (keydown)="onKyePress($event)"
              [attr.href]="childPage.pageUrl"
              [attr.target]="
                childPage?.openinnewTab === 'true' ? '_blank' : '_self'
              "
              data-src="travel-info_360_deltaOne.jpg"
              id="secondary-static-link-{{ y }}"
            >
              {{ childPage.pageName }}
              <img
                *ngIf="childPage.externalimage === 'true'"
                [src]="externalImgUrl"
                alt="{{ externalImgDesc }}"
              />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
